import { useNavigate } from "react-router-dom";
import { useTheme } from "../../../../../components/hooks/useTheme";
import { AllDamageTypes } from "./AllDamageTypes";
import colorConfigs from "../../../../../configs/colorConfigs";

export const DamageTypes = () => {
  const { themeStyles } = useTheme();
  const navigate = useNavigate();

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[1px] pb-[40px] flex flex-col gap-2.51`}>
        <div className="flex items-center justify-end">
          <div className="flex items-center gap-2.5">
            <button className={`px-[8px] py-[6px] ${colorConfigs.btn.main.tailwind} rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
              onClick={() => navigate("/admin/fleet/maintenance/adddamagetype")}
            >
              <span className="material-symbols-outlined text-[25px] font-light">
                add
              </span>
              <span className="text-xs font-medium">Damage Type</span>
            </button>
          </div>
        </div>

        <div>
          <AllDamageTypes />
        </div>
      </div>
    </div>
  )
}